module.exports = __webpack_public_path__ + "img/collections.786b447b.jpg";